import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import type { BiEvent } from '@wix/da-bi/pkg/events';

import s from './Page.scss';

export interface Props {
  page: number;
  isCurrent: boolean;
  getPageUrl?: (page: number) => string;
  onChangePage?: (newPage: number) => void;
  biData?: BiEvent;
}

const Page: React.FC<React.PropsWithChildren<Props>> = ({
  isCurrent,
  page,
  getPageUrl,
  onChangePage,
  children,
  biData,
}) => {
  const url = getPageUrl && getPageUrl(page);
  const onClick = onChangePage && (() => onChangePage(page));

  if (isCurrent || (!onClick && !url)) {
    return (
      <div className={classnames(s['page'], isCurrent && s['current'])}>
        {children}
      </div>
    );
  }

  if (url) {
    return (
      <BiLink
        biData={biData}
        className={s['page']}
        href={url}
        onClick={onClick}
      >
        {children}
      </BiLink>
    );
  }

  return (
    <BiButton biData={biData} className={s['page']} onClick={onClick}>
      {children}
    </BiButton>
  );
};
Page.displayName = 'Page';

export default Page;
